import React, {useState, useEffect, useRef} from 'react'
import {useForm} from 'react-hook-form'
import { collection, setDoc, doc, addDoc, getDocs, updateDoc, where, query, serverTimestamp} from "firebase/firestore";
import { db, storage } from "../firebase-config";
import {v4 as uuidv4} from 'uuid'
import Person from './Person';

export default function Edition(props) {

    const [submitSuccess, setSubmitSuccess] = useState()
    const [submitSuccess2, setSubmitSuccess2] = useState()
    const [validation, setValidation] = useState()
    const [validationMessage, setValidationMessage] = useState()
    const [personsIsEmpty, setPersonsIsEmpty] = useState(false)
    const [persons, setPersons] = useState([{}])
    const [checked, setChecked] = useState([])
    const [id, setId] = useState()

    const { register, handleSubmit, setError, reset, formState: {errors, isSubmitting, isSubmitted, isSubmitSuccessful }  } = useForm({
        mode: 'onChange',
        defaultValues: ''
})

    const { register: register2, handleSubmit: handleSubmit2, reset: reset2, setError: setError2, formState: {errors: errors2, isSubmitting: isSubmitting2, isSubmitted: isSubmitted2, isSubmitSuccessful: isSubmitSuccessful2 } } = useForm({
        mode: 'onChange',
        defaultValues: ''
})

useEffect(() => {
  const newArr = persons.filter(person => Object.keys(person).length !== 0)
  setPersons(newArr)
}, [])

useEffect(() => {
  if(props.defaultValues !== undefined) {
    reset(props.defaultValues);
    if(Object.keys(props.defaultValues).length > 0 && props.defaultValues.PERSONS.length > 0) {
      setPersons(props.defaultValues.PERSONS)
    } 
  } else {
    alert("Vous n'êtes pas encore inscrit, remplissez le formulaire ci-dessous")
  }
   
}, [props.defaultValues]);

useEffect(() => {
  if(props.defaultValues !== undefined) {
    if(Object.keys(props.defaultValues).length > 0) {
        setId(props.defaultValues.ID)
    } else {
        setId(uuidv4())
    }
  }
}, [props.defaultValues]);



const formRef = useRef()
const willBeThere = useRef()

const handleDelete = async (data) => {
  console.log(data);
  let newArr = persons.filter(person => person !== data)
  console.log(newArr);
  setPersons(newArr)
}

useEffect(() => {
  if(persons.length < 0) {
    setPersonsIsEmpty(true)
  }
}, [persons])

const handleCheck = async (e) => {
    if(!checked.includes(e.target.name)) {
      setChecked(checked =>  [e.target.name, ...checked])
    } else {
        setChecked(checked.filter(check => check !== e.target.name))
    }
  

    console.log(e);
}


console.log(personsIsEmpty);
const onSubmitSecond = async (data) => {

    console.log(data);

    let nom
    let prenom
    let email
    let tel
    let mercredi
    let jeudi
    let presenceM = 'Non renseigné'
    let presenceJ = 'Non renseigné'
   
    if(data.nom !== '') {
      nom = data.nom
    } else {
      nom = "/"
    }
    if(data.prenom !== '') {
       prenom = data.prenom
    } else {
       prenom = "/"
    }
    if(data.email !== '') {
       email = data.email
    } else {
       email = "/"
    }
    if(data.tel !== '') {
      if(data.tel.charAt(0) === '0') {
        tel = data.tel.slice(1)
      } else {
        tel = data.tel
      }
    } else {
      tel = "Non renseigné"
    }
    if(data.mercredi === true) {
       mercredi = 'Oui'
    } else {
       mercredi = "Non"
    }
    if(data.jeudi === true) {
       jeudi = 'Oui'
    } else {
       jeudi = "Non"
    }
    if(data.presenceM) {
        presenceM = data.presenceM
    } else {
       presenceM = "Non renseigné"
    }
    if(data.presenceJ) {
        presenceJ = data.presenceJ
    } else {
      presenceJ = "Non renseigné"
    }
 
    try {
      setPersons(persons =>  [{
        ID: uuidv4(),
        NOM: nom,
        PRENOM: prenom,
        EMAIL: email,
        TEL: tel,
        WED: mercredi,
        THUR: jeudi,
        PRESENCEWED: presenceM,
        PRESENCETHUR: presenceJ,
       }, ...persons])

       reset2("")
    }

    catch {

    }


  setPersonsIsEmpty(false)
  setSubmitSuccess2(true)
  console.log(persons);
  console.log(data);

  willBeThere.current.reset(undefined, { keepDirtyValues: true })
  // setTimeout(() => {
  //   nom = "/"
  //   prenom = "/"
  //   email = "/"
  //   tel = "Non renseigné"
  //   mercredi = "Non"
  //   jeudi = "Non"
  //   presenceM = "Non renseigné"
  //   presenceJ = "Non renseigné"
  //   console.log(data.nom);
  // }, 2000);
  console.log(data.nom);
  }


  useEffect(() => {
    console.log(checked);
  }, [checked])

  console.log(id);
  
const onSubmit = async (data) => {
    let organisme = "/"
    let email = "/"
 
    if(data.ORGANISME) {
      organisme = data.ORGANISME
    }
    if(data.EMAIL) {
      email = data.EMAIL
    }
 
      const info = {
        ID: id,
        ORGANISME: organisme,
        EMAIL: email,
        PERSONS: persons,
        date: new Date().toLocaleString().slice(0, 10)   
    }

    console.log(id);

    try {
   
          const ref = collection(db, "spro");
          if(Object.keys(props.defaultValues).length > 0) {
            await updateDoc(doc(ref, id), info)
          } else {
            await setDoc(doc(ref, id), info)
          }
      setValidation("success")
      setValidationMessage("Vos réponses ont bien été enregistrées")
    
  }
  catch(err) {
      console.log(err)
      setValidation("error")
      setValidationMessage("Une erreur s'est produite, veuillez réessayer ultérieurement")
  }
  setSubmitSuccess(true)
  formRef.current.reset("")
  }


  return (
    <div className='formContainer'>
        <form className="sign" ref={formRef} onSubmit={handleSubmit(onSubmit)}>
          <h4>Les champs marqués d'un * sont requis</h4>
            <input {...register('ORGANISME', {required: true, message: 'Ce champ est requis'})} type="text" name="ORGANISME" id="" placeholder='Organisme / structure *'/>
            {errors.ORGANISME?.type === "required" && (
                <small>Ce champ est requis</small>
            )}
            <input {...register('EMAIL', {required: true, message: 'Ce champ est requis'})} type="email" name="EMAIL" id="" placeholder='Email *'/>
            {errors.EMAIL?.type === "required" && (
                <small>Ce champ est requis</small>
            )}

            <button className='button2'>Envoyer</button>
        </form>
        <div className="personsWrapper">
          <div className={personsIsEmpty === true ? "persons empty" : "persons"}>
            {persons.length > 0 &&
              persons.map(person => {
                return <Person key={person.Id} data={person} delFunc={handleDelete}/>
              })
            } 
          </div>

         <form className={personsIsEmpty === true ? "willBeThere center" : "willBeThere"} ref={willBeThere} onSubmit={handleSubmit2(onSubmitSecond)}>
          <h3>Personnes présentes</h3>
            <input {...register2('nom')} type="text" name="nom" id="" placeholder='Nom'/>
            <input {...register2('prenom')} type="text" name="prenom" id="" placeholder='Prénom'/>
            <input {...register2('email')} type="email" name="email" id="" placeholder='Email'/>
            <div className="tel">
            <span>+33</span>
            <input {...register2('tel', {pattern: /^[0-9]/})} type="tel" name="tel" id="" maxLength="10" placeholder='Téléphone (facultatif)'/>
            </div>
            {errors2.tel && 
                <small>Veuillez entrer un numéro de téléphone valide</small>
            }
            <div className="chx">
            <label className='title'>Quel(s) jour(s) cette personne sera t-elle présente à Agora Jobs ?</label>
                <input {...register2('mercredi')} type="checkbox" onChange={(e) => handleCheck(e)}  name="mercredi" id="" />
                <label htmlFor="Mercredi">Mercredi</label>
                {checked.includes("mercredi") && 
                    <input {...register2('presenceM')} type="text" name="presenceM" id="" placeholder="Si pas présent toute la journée, précisez l'horaire"/>   
                }
                <input {...register2('jeudi')} type="checkbox"  onChange={(e) => handleCheck(e)} name="jeudi"  id="" />
                <label htmlFor="Jeudi">Jeudi</label>
                {checked.includes("jeudi") && 
                    <input {...register2('presenceJ')} type="text" name="presenceJ" id="" placeholder="Si pas présent toute la journée, précisez l'horaire"/>   
                }
            </div>
            <button>Ajouter une nouvelle personne</button>
         </form>

        </div>
     
    </div>
  )
}
